import io from "socket.io-client";

const socket = io("https://opt-mw-cw-tserv03.exceloid.in/");

const sendOrder = (order) => {
  socket.emit("newOrder", order);
};

export { socket, sendOrder };